/*
 * @Date: 2022-08-10 18:17:26
 * @LastEditTime: 2022-08-16 10:13:54
 * @Description:
 */
import { net_common } from "@/api/http";
export const API_DisplayAccessAuthorityList = (...params) =>
    net_common.post("/api/STDSDC05C06/DisplayAccessAuthorityList", ...params);

export const API_AccessAuthorityChange = (...params) =>
    net_common.post("/api/STDSDC05C06/AccessAuthorityChange", ...params);
